import * as yup from 'yup';
import { isValidIndonesianPhoneInput } from 'common-ts/dist/models/Phone';

// One yup rule for every phone field in the storefront (checkout sign-up,
// account sign-up, address edit, sign-in). The fields sit behind a "+62"
// adornment, so buyers type "812…" or "0812…"; both normalize the same way.
export const PHONE_ERROR = 'Nomor HP tidak valid. Gunakan nomor HP Indonesia aktif (contoh: 0812xxxxxxx)';
export const PHONE_REQUIRED = 'Nomor HP wajib diisi';

export function phoneNumberSchema(required: boolean) {
  const base = yup.string()
    .test('id-mobile', PHONE_ERROR, (value) => (!value ? !required : isValidIndonesianPhoneInput(value)));
  return required ? base.required(PHONE_REQUIRED) : base;
}
